<div class="video-status-page">

  <header class="page-header">
    <div class="page-header__content">
      <h1>Estado de Procesamiento</h1>
      <p class="subtitle">Supervisión en tiempo real del ciclo de vida de los videos</p>
    </div>

    <div class="header-actions">
      <button class="search-toggle-btn" (click)="toggleSearch()">
        <span class="material-icons">search</span>
        {{ isSearchOpen() ? 'Cerrar búsqueda' : 'Buscar vídeo' }}
      </button>

      @if (canRetry()) {
        <button class="reprocess-all-btn" (click)="onRetryAllVideos()" [disabled]="isRetryingAll()">
          <span class="material-icons">playlist_add_check_circle</span>
          {{ isRetryingAll() ? 'Lanzando reproceso...' : 'Reprocesar todos los vídeos' }}
        </button>
      }

      <button class="refresh-btn" (click)="refreshData()" [disabled]="statusService.isLoading() || isRetryingAll()">
        <span class="material-icons" [class.spinning]="statusService.isLoading()">refresh</span>
        {{ statusService.isLoading() ? 'Actualizando...' : 'Actualizar' }}
      </button>
    </div>
  </header>

  @if (isSearchOpen()) {
    <section class="search-row">
      <div class="search-box">
        <span class="material-icons">search</span>
        <input
          type="text"
          [value]="searchInputValue()"
          (input)="onSearchInputChange($any($event.target).value)"
          (keyup.enter)="applySearch()"
          placeholder="Buscar por título de vídeo"
        />
      </div>
      <button class="search-apply-btn" (click)="applySearch()">Aplicar</button>
      <button class="search-clear-btn" (click)="clearSearch()">Limpiar</button>
    </section>
  }

  <section class="status-overview">
    <div class="overview-grid">
      <article class="overview-card processing">
        <p class="label">En procesamiento (global)</p>
        <p class="value">{{ processingCount() }}</p>
      </article>
      <article class="overview-card queued">
        <p class="label">En cola (global)</p>
        <p class="value">{{ queuedCount() }}</p>
      </article>
      <article class="overview-card completed">
        <p class="label">Completos (global)</p>
        <p class="value">{{ completedCount() }}</p>
      </article>
      <article class="overview-card error">
        <p class="label">Con error (global)</p>
        <p class="value">{{ errorCount() }}</p>
      </article>
    </div>

    <div class="control-bar">
      <div class="filter-group">
        @for (filter of processFilters; track filter.value) {
          <button
            class="control-chip"
            [class.active]="statusService.processFilter() === filter.value"
            (click)="onProcessFilterChange(filter.value)"
          >
            {{ filter.label }}
          </button>
        }
      </div>

      <div class="sort-group">
        @for (option of sortOptions(); track option.value) {
          <button
            class="control-chip"
            [class.active]="statusService.sortOrder() === option.value"
            (click)="onSortOrderChange(option.value)"
          >
            {{ option.label }}
          </button>
        }
      </div>
    </div>

    @if (statusService.processFilter() === 'queued') {
      <p class="queue-note">
        La cola usa posición real del orquestador (prioridad y cola normal).
      </p>
    }

    @if (hasCustomView()) {
      <p class="view-hint">
        Vista activa: <strong>{{ activeFilterLabel() }}</strong> · Orden: <strong>{{ currentSortLabel() }}</strong>
      </p>
    }
  </section>

  @if (statusService.error()) {
    <div class="state-container error">
      <span class="material-icons icon">error_outline</span>
      <h3>Error de conexión</h3>
      <p>{{ statusService.error() }}</p>
      <button class="retry-action" (click)="refreshData()">Intentar de nuevo</button>
    </div>
  }

  @else if (!statusService.isLoading() && !statusService.hasActiveProcesses()) {
    <div class="state-container empty">
      <span class="material-icons icon">task_alt</span>
      <h3>Sin resultados</h3>
      <p>{{ emptyStateMessage() }}</p>
    </div>
  }

  @else {
    <div class="cards-grid">
      @for (status of statusService.activeProcesses(); track status.video_id) {
        <app-video-status-card
          [status]="status"
          [showProcessingStages]="canRetry()"
          (retryClicked)="onRetryVideo($event)"
          (archiveClicked)="onArchiveVideo($event)"
          (prioritizeClicked)="onPrioritizeVideo($event)"
          (cardClicked)="onCardClick($event)"
          [canRetry]="canRetry()"
        />
      }
    </div>

    <mat-paginator
      class="custom-paginator"
      [length]="statusService.totalItems()"
      [pageSize]="statusService.pageSize()"
      [pageSizeOptions]="[9]"
      [hidePageSize]="true"
      [pageIndex]="statusService.currentPage() - 1"
      (page)="onPageEvent($event)"
      showFirstLastButtons
      aria-label="Seleccionar página de videos">
    </mat-paginator>
  }
</div>
